export const styles = {
    title: {
        fontSize: 'clamp(2rem, 5vw, 6rem)'
    }
};
